import { usageIds } from "../constants/usageid.js";
export var ResellerSchemaIds;
(function (ResellerSchemaIds) {
    ResellerSchemaIds["RESELLER"] = "reseller";
})(ResellerSchemaIds || (ResellerSchemaIds = {}));
export var ResellerTags;
(function (ResellerTags) {
    ResellerTags["DEFAULT"] = "default";
})(ResellerTags || (ResellerTags = {}));
export const ResellerTagsMap = {
    [ResellerSchemaIds.RESELLER]: [ResellerTags.DEFAULT],
};
export const ResellerUsageIds = usageIds(ResellerTagsMap);
